import { render, staticRenderFns } from "./schoolInformation.vue?vue&type=template&id=280d3354&scoped=true&"
import script from "./schoolInformation.vue?vue&type=script&lang=js&"
export * from "./schoolInformation.vue?vue&type=script&lang=js&"
import style0 from "./schoolInformation.vue?vue&type=style&index=0&id=280d3354&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d3354",
  null
  
)

export default component.exports